module.exports = __webpack_public_path__ + "img/trustworthy.ed9a87f1.png";